import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormEdit } from '../components';
import Swal from 'sweetalert2';
import schema from './schema'
import { showValorReferencia, loadValorReferencias, updateValorReferencia } from '~/store/modules/valor_referencia/action';
import { Loading } from '~/components';
import initialData from '../../MeioAnalise/Edit/initialData';
import { loadPorteEmpreendimentos } from '~/store/modules/porte_empreendimento/action';

const Edit = () => {
  let history = useHistory();
  const [valor_referencia_edit, setValorReferenciaEdit] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const { tipo_licenca_id, valor_referencia_id }  = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors, valor_referencia } = useSelector(({ ValorReferenciaReducer }) => ValorReferenciaReducer);

  useEffect(() => {
    dispatch(showValorReferencia(valor_referencia_id));
  }, [dispatch, valor_referencia_id]);

  useEffect(() => {
    dispatch(loadPorteEmpreendimentos())
  }, [dispatch]);


  useEffect(() => {
    // console.log('errors Edit: ',errors);
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setSaved(errors.update);
    }
  }, [errors]);

  useEffect(() => {
    if (valor_referencia !== {}) {
      setValorReferenciaEdit({
        valor: valor_referencia.valor,
        porte_empreendimento_id: valor_referencia.porte_empreendimento_id,
        potencial_poluidor_id: valor_referencia.potencial_poluidor_id,
        tipo_licenca_id: valor_referencia.tipo_licenca_id
      });
    }
  }, [valor_referencia, status_response]);

  useEffect(() => {
    if (saved && status_response === 200) {
      Swal.fire('Sucesso', 'Registro editado com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadValorReferencias({
            where:`tipo_licenca_id:${tipo_licenca_id}`,
          }));
        }
      );
    }
  }, [status_response, history, dispatch, saved, tipo_licenca_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrorsValidate([]);
    if (!schema.isValidSync(valor_referencia_edit)) {
      let yup_errors = {};
      schema.validate(valor_referencia_edit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      // console.log('atividade_edit update: ',parseInt(valor_referencia_edit.valor));
      let updateData = valor_referencia_edit;
      await dispatch(updateValorReferencia(updateData, valor_referencia_id));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-md"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Valor de Referência
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {
              valor_referencia_edit?
                (
                  <FormEdit
                    errors={errorsValidate}
                    handleSubmit={handleSubmit}
                    schema={schema}
                    setValorReferenciaEdit={setValorReferenciaEdit}
                    valorReferencia={valor_referencia_edit}
                  />
                ):
                (
                  <Loading />
                )
            }
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_valor_referencia"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Editar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
